var themeContract = {
  argos: {
    legal: {
      color: 'brand-1',
      colorHover: 'brand-1-dark'
    }
  },
  habitat: {
    legal: {
      color: 'brand-1',
      colorHover: 'brand-1-dark'
    }
  },
  tu: {
    legal: {
      color: 'brand-1',
      colorHover: 'brand-1-dark'
    }
  },
  nectar: {
    legal: {
      color: 'brand-1',
      colorHover: 'brand-1-dark'
    }
  },
  sainsburys: {
    legal: {
      color: 'brand-2',
      colorHover: 'brand-2-dark'
    }
  }
};
export { themeContract };